<template>
    <div>
        <div class="group shadow mb-6 cursor-pointer text-grey-darkest leading-normal rounded" @click="handleClick">
            <div class="flex items-top p-3 md:p-6 bg-white rounded-t">
                <partner-avatar :external-url="office.doctorAvatar" class="mr-2 w-10 h-10 md:w-12 md:h-12"></partner-avatar>
                <div class="ml-4">
                    <div class="flex items-center">
                        <!-- <span class="icon mr-2 text-lg text-blue-light"><i class="mdi mdi-account"></i></span> -->
                        <span class="text-sm md:text-base font-bold">{{ office.doctorFirstName + ' ' + office.doctorLastName }}</span>
                    </div>
                    <div class="flex items-top md:mt-1">
                        <span class="icon mr-2 text-sm text-grey"><i class="mdi mdi-map-marker"></i></span>
                        <span class="text-sm text-grey font-semi-bold">{{ office.officeZipCode }} {{ office.officeLocality }}</span>
                    </div>
                    <div class="flex">
                        <template v-if="office.isDoctorRegulated && (office.medicalPractice !== 'OSTEOPATH' && office.medicalPractice !== 'PSYCHOLOGIST')">
                            <span class="icon mr-2 text-sm text-green"><i class="mdi mdi-currency-eur"></i></span>
                            <span class="text-sm text-green">{{ $t('Contracted_doctor') }}</span>
                        </template>
                        <template v-if="!office.isDoctorRegulated && (office.medicalPractice !== 'OSTEOPATH' && office.medicalPractice !== 'PSYCHOLOGIST')">
                            <span class="icon mr-2 text-sm text-red"><i class="mdi mdi-currency-eur"></i></span>
                            <span class="text-sm text-red">{{ $t('Contracted_doctor_negative') }}</span>
                        </template>
                    </div>
                </div>
            </div>
            <div class="transition flex rounded-b bg-grey-light group-hover:bg-blue text-grey-darker group-hover:text-white py-1 justify-center">
                <span class="uppercase tracking-wide font-semibold text-sm">{{ $t('See_office_availabilities') }}</span>
            </div>
        </div>
    </div>
</template>
<script>
    import helpers from '@/mixins/helpers'

    import PartnerAvatar from '@/components/PartnerAvatar.vue'

    export default {
        name: 'partner-office-list-item',

        components: { PartnerAvatar },

        mixins: [helpers],

        props: ['office'],

        methods: {
            handleClick () {
                this.$router.push({ name: 'partner-office.show', query: {
                    doctorId: this.office.doctorId,
                    medicalPractice: this.office.medicalPractice,
                    latitude: this.office.officeLatitude,
                    longitude: this.office.officeLongitude,
                } })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Patient/PartnerOfficeListItem.vue